import React from 'react';
import '../NotExisting/NotExisting.css'
const NotExisting = () => {
    return (
        <div className="not-found-route">
            <h2>Opps Sorry! Route Not NotExisting</h2>
            <h2>Please Enter Correct Path</h2>
        </div>
    );
};

export default NotExisting;